// Variables.scss 동일한 기준 적용할 것, 여기 수정되면 동기화 필요
const SCREEN_SIZES = {
  MOBILE_SCREEN_WIDTH: 768, // 모바일 화면 최대 너비
  TABLET_SCREEN_WIDTH: 1024, // 태블릿 화면 최대 너비
};

export default SCREEN_SIZES;
